import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useFormik } from "formik";
import { useDispatch, useSelector, } from "react-redux";
import { workspace } from "../../store/modules/workspace";
import { WorkspaceRequestInit, } from "../../model/request/workspace/CreateWorkspaceRequest";
import { BaseInput } from "../input/BaseInput";
import { WorkspaceValidation } from "../formik/validation/WorkspaceValidation";
import { useNavigate } from "react-router-dom";
import { RouteConstant } from "../../util/constant/RouteConstant.ts";
// import {useNavigate} from "react-router-dom";
// import {RouteConstant} from "../../util/constant/RouteConstant.ts";
export default function CreateWorkspace() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const workspaceState = useSelector((state) => state.workspace);
    const handleSubmit = (value) => {
        dispatch(workspace.mutation.setCreateWorkSpaceBilling(value));
        formik.resetForm();
        navigate(RouteConstant.dashboard.billing.path);
    };
    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: WorkspaceRequestInit,
        validationSchema: WorkspaceValidation.create,
    });
    return (_jsx(_Fragment, { children: _jsxs("section", { className: "app-content-dashboard", style: { backgroundColor: "white" }, children: [_jsx("div", { className: "title-wrapper", children: _jsx("div", { className: "margin-bottom", children: _jsx("h5", { children: "Create Workspace" }) }) }), _jsx("div", { className: "workspace-body", children: _jsxs("div", { className: "workspace-content", children: [_jsx("p", { children: "Name your Workspace" }), _jsxs("form", { onSubmit: formik.handleSubmit, children: [_jsxs("div", { className: "workspace-field", children: [_jsx("label", { children: "Name" }), _jsx(BaseInput, { formik: formik, type: "text", placeholder: "Example: My Workspace", name: "workspaceName" })] }), _jsxs("div", { className: "workspace-field", children: [_jsx("label", { children: "Description" }), _jsx(BaseInput, { formik: formik, type: "text", placeholder: "Description", name: "workspaceDescription" })] }), _jsx("div", { className: "workspace-button", children: _jsx(BaseInput, { type: "submit", formik: formik, name: "submit", value: "Create your workspace", loading: workspaceState.loading, style: {
                                                backgroundColor: "#da8e34",
                                                color: "#fff",
                                                borderRadius: "4px",
                                                padding: "8px 15px",
                                                fontSize: "12px",
                                                border: "none",
                                            } }) })] })] }) })] }) }));
}
